import { CellProps } from 'react-table';
import { TableCustomCell } from '../../../../component/table/components/TableCustomCell';
import { formatMoney } from '../../../../utils/FormatUtils';

const IntoMoneyCell = ({ row, tableOptions }: CellProps<any>) => {
	const { handleRenderPrice } = tableOptions;
	const rowData = row.original;

	const visitObjectTypeCode = rowData?.visitObjectType?.code;
	const data =
		handleRenderPrice(rowData, visitObjectTypeCode) * (rowData?.attributes?.svcQuantity || 1);

	return <TableCustomCell className="text-end " data={data ? formatMoney(data) : 0} />;
};

export default IntoMoneyCell;
